import type { CSSProperties } from 'react';

interface Props {
  children?: React.ReactNode;
  light?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function FieldSignal({
  children = 'FIELD SIGNAL · LIVE · 2026',
  light = false,
  className = '',
  style,
}: Props) {
  const tone = light
    ? 'text-carbon bg-papel/60 border-carbon/20'
    : 'text-papel bg-carbon/40 border-papel/15';
  return (
    <div
      className={
        'inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full ' +
        'font-mono text-[10px] tracking-[0.2em] uppercase ' +
        'backdrop-blur-md border ' + tone + ' ' + className
      }
      style={style}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-senal shadow-[0_0_10px_rgba(200,255,62,0.7)] field-signal-dot" />
      <span>{children}</span>
    </div>
  );
}
